import isNil from 'lodash/isNil'

export default function convertCentsToDollars(
  value: string | number | null | undefined,
): number | undefined {
  if (isNil(value)) {
    return undefined
  }

  const centsAmount =
    typeof value === 'string' ? parseInt(value.trim(), 10) : value

  return Math.round((centsAmount / 100 + Number.EPSILON) * 100) / 100
}
